<!-- Map Div -->
<div class="map-container">
  <div #mapViewNode id="mapViewNode"></div>
</div>